import { toastr } from "react-redux-toastr";

/**
 * expected object properties : status, title, message, direction(optional)
 * @param {Object}
 * @returns
 */
export default function toaster({
    status = "success",
    title = "",
    message = "",
    position = "top-right",
    ...rest // any other properties like: timeOut, component
} = {}) {
    let alert = null;
    switch (status.toLowerCase()) {
        case "success":
            alert = toastr.success(title, message, { position, ...rest }); // spread any other properties into the Object
            break;
        case "error":
            alert = toastr.error(title, message, { position, ...rest });
            break;
        case "warning":
            alert = toastr.warning(title, message, { position, ...rest });
            break;
        default:
            break;
    }
    return alert;
}
